(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["anbefalt-tilbehor"] && !Shopify.designMode) return;
  try {
    (function () {
    function fmt(cents, format) {
      var c = Number(cents) || 0;
      function num(n, d, ts, ds) {
        var s = (n / 100).toFixed(d).split('.');
        s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
        return s[1] ? s[0] + ds + s[1] : s[0];
      }
      var f = format || 'kr [a]';
      if (f.indexOf('{') < 0) return f.replace('[a]', num(c, 2, '.', ','));
      return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        switch (k) {
          case 'amount_no_decimals': return num(c, 0, ',', '.');
          case 'amount_with_comma_separator': return num(c, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return num(c, 0, '.', ',');
          case 'amount_with_space_separator': return num(c, 2, ' ', ',');
          default: return num(c, 2, ',', '.');
        }
      });
    }

    if (!customElements.get('anbefalt-tilbehor')) {
      customElements.define('anbefalt-tilbehor', class extends HTMLElement {
        connectedCallback() {
          try { this.data = JSON.parse(this.querySelector('[data-tilbehor-variants]').textContent); }
          catch (e) { this.data = { variants: {} }; }
          this.update = this.update.bind(this);
          this.addEventListener('change', this.update);
          this.onDoc = (e) => {
            if (e.type === 'variant:update' && e.detail && e.detail.resource && e.detail.resource.id != null && this.data.avail) {
              this.data.avail[String(e.detail.resource.id)] = !!e.detail.resource.available;
            }
            if (e.type === 'variant:update' || (e.target && e.target.name === 'quantity')) setTimeout(this.update, 50);
          };
          document.addEventListener('variant:update', this.onDoc);
          document.addEventListener('change', this.onDoc);
          document.addEventListener('input', this.onDoc);
          this.update();
        }
        disconnectedCallback() {
          document.removeEventListener('variant:update', this.onDoc);
          document.removeEventListener('change', this.onDoc);
          document.removeEventListener('input', this.onDoc);
        }
        get form() { return document.getElementById(this.dataset.formId); }
        mainVariantId() {
          var f = this.form, i = f && f.querySelector('input[name="id"]');
          return i ? String(i.value) : Object.keys(this.data.variants)[0];
        }
        mainQty() {
          var f = this.form;
          var q = (f && f.querySelector('input[name="quantity"]')) ||
            document.querySelector('input[name="quantity"][form="' + this.dataset.formId + '"]') ||
            (f && f.closest('product-form-component') && f.closest('product-form-component').querySelector('input[name="quantity"]'));
          var n = q ? parseInt(q.value, 10) : 1;
          return n > 0 ? n : 1;
        }
        checked() { return Array.from(this.querySelectorAll('.tilbehor__cb:checked')); }
        update() {
          var vid = this.mainVariantId();
          var ok = !this.data.avail || this.data.avail[vid] !== false;
          if (!ok && this.checked().length) this.checked().forEach(function (cb) { cb.checked = false; });
          this.hidden = !ok;
          var main = (this.data.variants[this.mainVariantId()] || 0) * this.mainQty();
          var sum = this.checked().reduce(function (s, cb) { return s + Number(cb.dataset.price || 0); }, main);
          var out = this.querySelector('[data-tilbehor-total]');
          if (out) out.textContent = fmt(sum, this.data.moneyFormat);
        }
        clear() { this.checked().forEach(function (cb) { cb.checked = false; }); this.update(); }
      });
    }

    // Ett kall: gjør temaets eget /cart/add-kall om til items[] når tilbehør er avkrysset.
    if (!window.__tilbehorFetchPatched) {
      window.__tilbehorFetchPatched = true;
      var orig = window.fetch.bind(window);
      window.fetch = function (input, init) {
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          var body = init && init.body;
          if (/\/cart\/add(\.js)?(\?|$)/.test(url) && body instanceof FormData && body.get('id')) {
            var pid = String(body.get('product-id') || '');
            var blocks = Array.from(document.querySelectorAll('anbefalt-tilbehor')).filter(function (el) {
              return (!pid || el.dataset.productId === pid) && !el.hidden;
            });
            var extra = [];
            blocks.forEach(function (el) { el.checked().forEach(function (cb) { extra.push(cb.value); }); });
            if (extra.length) {
              var fd = new FormData();
              fd.append('items[0][id]', body.get('id'));
              fd.append('items[0][quantity]', body.get('quantity') || '1');
              body.forEach(function (v, k) {
                var m = k.match(/^properties\[(.+)\]$/);
                if (m) fd.append('items[0][properties][' + m[1] + ']', v);
                else if (k === 'selling_plan' && v) fd.append('items[0][selling_plan]', v);
                else if (k === 'sections' || k === 'sections_url') fd.append(k, v);
              });
              extra.forEach(function (id, i) {
                fd.append('items[' + (i + 1) + '][id]', id);
                fd.append('items[' + (i + 1) + '][quantity]', '1');
              });
              var newUrl = url.replace(/\/cart\/add(\.js)?/, '/cart/add.js');
              var newInit = Object.assign({}, init, { body: fd });
              return orig(newUrl, newInit).then(function (res) {
                if (res.ok) blocks.forEach(function (el) { el.clear(); });
                return res;
              });
            }
          }
        } catch (e) { console.error('tilbehør', e); }
        return orig(input, init);
      };
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pv-beskrivelse"] && !Shopify.designMode) return;
  try {
    (function () {
    function apne() {
      if (!window.matchMedia('(min-width: 750px)').matches) return;
      document.querySelectorAll('.pv-trekk__rad[data-apen-desktop]').forEach(function (d) { d.open = true; d.removeAttribute('data-apen-desktop'); });
    }
    function mobilTrekk() {
      if (window.matchMedia('(min-width: 750px)').matches) return;
      document.querySelectorAll('.pv-beskrivelse--mobil-trekk:not([data-trekk-klar])').forEach(function (b) {
        b.setAttribute('data-trekk-klar', '');
        var tekst = b.querySelector('.pv-beskrivelse__tekst');
        var trekk = b.querySelector('.pv-trekk');
        var klipp = b.querySelector('.pv-beskrivelse__ingress') || tekst;
        var start = klipp === tekst ? 1 : 0;
        if (tekst && trekk && tekst.children.length > start) {
          var rest = [].slice.call(tekst.children, start);
          var d = document.createElement('details');
          d.className = 'pv-trekk__rad pv-trekk__rad--body';
          d.innerHTML = '<summary>Beskrivelse</summary><div class="pv-trekk__innhold rte"></div>';
          rest.forEach(function (el) { d.lastChild.appendChild(el); });
          trekk.insertBefore(d, trekk.firstChild);
          if (klipp !== tekst) { tekst.hidden = !tekst.textContent.trim(); }
        }
        if (!klipp) return;
        klipp.classList.add('pv-klipp');
        var knapp = b.querySelector('.pv-les-mer');
        if (knapp && klipp.scrollHeight > klipp.clientHeight + 4) {
          klipp.after(knapp);
          knapp.hidden = false;
          knapp.addEventListener('click', function () {
            var apen = klipp.classList.toggle('pv-klipp--apen');
            knapp.textContent = apen ? 'Vis mindre' : 'Les mer';
            knapp.setAttribute('aria-expanded', apen ? 'true' : 'false');
          });
        }
      });
    }
    function init() { apne(); mobilTrekk(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pv-levering"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.pvLagerdato) return;
    var MND = ['januar','februar','mars','april','mai','juni','juli','august','september','oktober','november','desember'];
    var MK = ['jan.','feb.','mars','apr.','mai','juni','juli','aug.','sep.','okt.','nov.','des.'];
    function idag() { var d = new Date(); return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
    function forste(liste) {
      var i = idag(), best = '';
      (liste || '').split(',').forEach(function (d) { d = d.trim(); if (/^\d{4}-\d{2}-\d{2}$/.test(d) && d >= i && (!best || d < best)) best = d; });
      return best;
    }
    function tekst(d, kort) {
      var p = d.split('-'), y = +p[0], m = +p[1] - 1, dag = +p[2];
      var s = dag + '. ' + (kort ? MK[m] : MND[m]);
      if (y !== new Date().getFullYear()) s += ' ' + y;
      return s;
    }
    function produkt() {
      document.querySelectorAll('.pv-levering').forEach(function (el) {
        var span = el.querySelector('[data-lagerdato]');
        var mal = el.querySelector('.pv-levering__status-tekst');
        if (!span || !mal) return;
        if (!mal.hasAttribute('data-original')) mal.setAttribute('data-original', mal.textContent);
        var d = el.classList.contains('pv-levering--utsolgt') ? forste(span.getAttribute('data-lagerdato')) : '';
        var ny = d ? 'Utsolgt - forventes på lager ' + tekst(d, false) : mal.getAttribute('data-original');
        if (mal.textContent !== ny) mal.textContent = ny;
        el.classList.toggle('pv-levering--har-dato', !!d);
      });
    }
    function kort() {
      document.querySelectorAll('.pv-kort-lagerdato').forEach(function (el) {
        var d = forste(el.getAttribute('data-lagerdatoer'));
        var ny = d ? 'Forventes ' + tekst(d, true) : '';
        if (el.textContent !== ny) el.textContent = ny;
        if (el.hidden !== !d) el.hidden = !d;
      });
    }
    function alt() { produkt(); kort(); }
    window.pvLagerdato = alt;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alt); else alt();
    document.addEventListener('variant:update', function () { setTimeout(produkt, 0); setTimeout(produkt, 300); });
    var tid;
    new MutationObserver(function () { clearTimeout(tid); tid = setTimeout(kort, 150); }).observe(document.documentElement, { childList: true, subtree: true });
  })();

  if (!window.__pvOppdater) {
    window.__pvOppdater = true;
    document.addEventListener('variant:update', function (e) {
      var html = e.detail && e.detail.data && e.detail.data.html;
      if (!html || !html.getElementById) return;
      document.querySelectorAll('[data-pv-oppdater]').forEach(function (el) {
        var n = html.getElementById(el.id);
        if (n) { el.innerHTML = n.innerHTML; el.className = n.className; }
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pv-meta"] && !Shopify.designMode) return;
  try {
    if (!window.__pvOppdater) {
    window.__pvOppdater = true;
    document.addEventListener('variant:update', function (e) {
      var html = e.detail && e.detail.data && e.detail.data.html;
      if (!html || !html.getElementById) return;
      document.querySelectorAll('[data-pv-oppdater]').forEach(function (el) {
        var n = html.getElementById(el.id);
        if (n) el.innerHTML = n.innerHTML;
        if (n) el.className = n.className;
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pv-passer-til"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pv-passer-til')) {
    customElements.define('pv-passer-til', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('.pv-passer__knapp');
          if (btn) this.add(btn);
        });
      }
      async add(btn) {
        const tekst = btn.innerHTML;
        btn.setAttribute('aria-busy', 'true');
        try {
          const sections = Array.from(document.querySelectorAll('cart-items-component'))
            .map((el) => el.dataset.sectionId).filter(Boolean);
          const body = { items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] };
          if (sections.length) body.sections = sections.join(',');
          const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          const data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'Feil');
          const cart = await (await fetch(root + 'cart.js')).json();
          try {
            const { CartAddEvent } = await import('@theme/events');
            btn.dispatchEvent(new CartAddEvent(cart, String(btn.dataset.variantId), {
              source: 'pv-passer-til', itemCount: 1, productId: btn.dataset.productId, sections: data.sections,
            }));
          } catch (err) {
            document.querySelectorAll('.cart-count, [data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
          }
          btn.innerHTML = '<span class="pv-passer__pluss" aria-hidden="true">✓</span><span class="pv-passer__ktekst">Lagt til</span>';
        } catch (err) {
          console.error(err);
          btn.innerHTML = '<span class="pv-passer__pluss" aria-hidden="true">!</span><span class="pv-passer__ktekst">Kunne ikke legge til</span>';
        }
        btn.removeAttribute('aria-busy');
        setTimeout(() => { btn.innerHTML = tekst; }, 2500);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
